import * as React from 'react';

interface Props {
    goldValue: number;
    size?: 'large';
}

export default class CurrencyNumber extends React.PureComponent<Props, {}> {
    render() {
        const { goldValue, size } = this.props;

        let classNames: Array<string> = ['ddbc-currency-number'];
        if (size) {
            classNames.push(`ddbc-currency-number--${size}`);
        }

        return (
            <span className={classNames.join(' ')}>
                <span className="ddbc-currency-number__number">{goldValue}</span>
                <span className="ddbc-currency-number__label">gp</span>
            </span>
        );
    }
}
